<template>
  <div class="menubar-area">
    <div class="toolbar-inner menubar-nav">
      <router-link :to="{name: menuItem.route}" v-for="(menuItem,index) in leftMenu" :key="index" class="nav-link" :class="activeUrl('home') ? 'active' : ''">
        <span v-html="menuItem.icon"></span>
        <p>{{ menuItem.title }}</p>
      </router-link>
      <div class="navigation" data-bs-toggle="modal" data-bs-target="#callModal">
        <div class="menuToggle"><i></i></div>
      </div>
      <router-link :to="{name: menuItem.route}" v-for="(menuItem,index) in rightMenu" :key="index" class="nav-link" :class="activeUrl('action') ? 'active' : ''">
        <span v-html="menuItem.icon"></span>
        <p>{{ menuItem.title }}</p>
      </router-link>
    </div>
  </div>

</template>

<script setup>

import {useRoute} from "vue-router";

const route = useRoute()

const leftMenu = [
  {
    title: "Accueil",
    icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" fill=\"none\" xmlns:v=\"https://vecta.io/nano\"><path d=\"M21.44 11.035a.75.75 0 0 1-.69.465H18.5V19a2.25 2.25 0 0 1-2.25 2.25h-3a.75.75 0 0 1-.75-.75V16a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75v4.5a.75.75 0 0 1-.75.75h-3A2.25 2.25 0 0 1 3.5 19v-7.5H1.25a.75.75 0 0 1-.69-.465.75.75 0 0 1 .158-.818l9.75-9.75A.75.75 0 0 1 11 .246a.75.75 0 0 1 .533.222l9.75 9.75a.75.75 0 0 1 .158.818z\" fill=\"#bfc9da\"/></svg>",
    route: "home-page",
  }
]
const rightMenu = [
  {
    title: "Suivi",
    icon: "<svg xmlns=\"http://www.w3.org/2000/svg\" enable-background=\"new 0 0 24 24\" height=\"24px\" viewBox=\"0 0 24 24\" width=\"24px\" fill=\"#bfc9da\"><g><rect fill=\"none\" height=\"24\" width=\"24\"></rect></g><g><g><g><path d=\"M23,8c0,1.1-0.9,2-2,2c-0.18,0-0.35-0.02-0.51-0.07l-3.56,3.55C16.98,13.64,17,13.82,17,14c0,1.1-0.9,2-2,2s-2-0.9-2-2 c0-0.18,0.02-0.36,0.07-0.52l-2.55-2.55C10.36,10.98,10.18,11,10,11s-0.36-0.02-0.52-0.07l-4.55,4.56C4.98,15.65,5,15.82,5,16 c0,1.1-0.9,2-2,2s-2-0.9-2-2s0.9-2,2-2c0.18,0,0.35,0.02,0.51,0.07l4.56-4.55C8.02,9.36,8,9.18,8,9c0-1.1,0.9-2,2-2s2,0.9,2,2 c0,0.18-0.02,0.36-0.07,0.52l2.55,2.55C14.64,12.02,14.82,12,15,12s0.36,0.02,0.52,0.07l3.55-3.56C19.02,8.35,19,8.18,19,8 c0-1.1,0.9-2,2-2S23,6.9,23,8z\"></path></g></g></g></svg>",
    route: "orders-page",
  }
]

function activeUrl(url){
  let home = ["home-page","menu-page", ];
  let actions = ["orders-page", "orders-details-page"];

  if(url=="home" && home.includes(route.name)){
    return true
  }

  if(url=="action" && actions.includes(route.name)){
    return true
  }
}
</script>

<style scoped>
.menubar-area{
  width: 100%;
  height: 60px;
  padding: 0px;
  background-color: white;
  border-radius: 20px 20px 0 0;
  box-shadow: 0 -8px 20px -7px rgba(179, 179, 179, 0.21);
}
.menubar-nav{
  justify-content: center;
  justify-items: center;
}

.menubar-area .toolbar-inner .nav-link{
  width: 33%;
}

.menubar-area .toolbar-inner .active p{
  color: #2da333;
}

.menubar-area .toolbar-inner .nav-link p{
  margin-bottom: 0px;
}

.navigation{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.menuToggle{
  position: relative;
  width: 65px;
  height: 65px;
  background-color: #2da333;
  border: 10px solid white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  transform: translateY(-15px);
}

.menuToggle::before{
  content: '\f0f3';
  font-family: FontAwesome;
  text-decoration: inherit;
  position: absolute;
  font-size: 22px;
  color: white;
}

menuToggle i{
  position: absolute;
  inset: 0;
}

.menuToggle i::before{
  content: '';
  position: absolute;
  top: 25px;
  left: -23px;
  width: 20px;
  height: 20px;
  background: transparent;
  border-top-right-radius: 20px;
  box-shadow: 3px -6px white;
}

.menuToggle i::after{
  content: '';
  position: absolute;
  top: 25px;
  right: -23px;
  width: 20px;
  height: 20px;
  background: transparent;
  border-top-left-radius: 20px;
  box-shadow: -3px -6px white;
}
</style>